import { z } from 'zod';

import type { TFunction } from 'i18next';

import { refineTerminalMerchantId, terminalFormShape } from './common';

export function createCashierTerminalFormSchema(t: TFunction) {
  return z
    .object({
      ...terminalFormShape(t),
      cashier_id: z
        .string({ message: t('validation_required') })
        .min(1, { message: t('validation_required') }),
    })
    .superRefine(refineTerminalMerchantId(t));
}

export type CashierTerminalFormValues = z.infer<
  ReturnType<typeof createCashierTerminalFormSchema>
>;
